// NPM
import React from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

function renderDatapoint(datapoint, datapointIndex) {
  return (
    <tr className="Tooltip__value" key={`Tooltip__value-${datapointIndex}`}>
      <td>
        <span
          className="Tooltip__value-party-color"
          style={{ background: datapoint.color }}
        />
      </td>
      <td>{datapoint.label}</td>
      <td>{datapoint.value.toFixed(1)}</td>
    </tr>
  );
}

function Tooltip(props) {
  const { tooltipData } = props;

  const top = _.get(tooltipData, "position.y", 0);
  const left = _.get(tooltipData, "position.x", 0);
  const opacity = _.get(tooltipData, "opacity", 0);
  const datapoints = _.get(tooltipData, "datapoints", []);

  return (
    <div className="Tooltip" style={{ top, left, opacity }}>
      <div className="Tooltip__title">{props.tooltipData.title}</div>

      <table className="Tooltip__values">
        <tbody>{datapoints.map(renderDatapoint)}</tbody>
      </table>
    </div>
  );
}

export default Tooltip;
